import { Link, useParams } from "react-router-dom";
import PageHeader from "@/components/feature/PageHeader";
import Badge from "@/components/base/Badge";
import { products } from "@/mocks/products";

export default function ProductDetail() {
  const { id } = useParams();
  const product = products.find((item) => item.id === id);

  if (!product) {
    return (
      <div>
        <PageHeader title="Producto" backTo="/productos" />
        <div className="flex flex-col items-center gap-3 px-5 py-16 text-center">
          <i className="ri-shopping-bag-3-line text-3xl text-foreground-400" />
          <p className="font-heading text-base font-bold text-foreground-950">
            No encontramos este producto
          </p>
          <Link
            to="/productos"
            className="cursor-pointer font-label text-sm font-semibold text-accent-700"
          >
            Volver al catálogo
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="animate-fade-in">
      <PageHeader title="Detalle del producto" backTo="/productos" />

      <div className="relative flex h-[420px] w-full items-center justify-center overflow-hidden bg-gradient-to-br from-background-100 via-background-50 to-accent-50/40 px-4 py-5">
        <img
          src={product.image}
          alt={`${product.name} — ${product.category} ALÉA Skin`}
          title={`${product.name} ALÉA Skin`}
          decoding="async"
          className="h-full w-full object-contain object-center drop-shadow-2xl"
        />
        <span className="absolute left-5 top-5">
          <Badge tone="accent">{product.category}</Badge>
        </span>
        <span className="absolute bottom-5 left-5 rounded-full bg-background-50/90 px-3 py-1.5 font-label text-[10px] font-bold uppercase tracking-[0.2em] text-primary-700 shadow-soft backdrop-blur">
          {product.statusLabel ?? "Proximamente"}
        </span>
      </div>

      <div className="flex flex-col gap-4 px-5 py-5">
        <div>
          <h1 className="font-heading text-xl font-extrabold leading-tight text-foreground-950">
            {product.name}
          </h1>
          <p className="mt-1 inline-flex items-center gap-1.5 text-sm font-semibold text-accent-700">
            <i className="ri-sparkling-2-line text-base leading-none" />
            {product.benefit}
          </p>
        </div>

        <div className="rounded-2xl border border-accent-200 bg-accent-50/70 p-4">
          <p className="font-label text-[10px] font-bold uppercase tracking-[0.22em] text-accent-700">
            Lanzamiento próximo
          </p>
          <p className="mt-1.5 text-sm leading-relaxed text-foreground-700">
            Este producto aún no está disponible para compra dentro de la app. Lo mostramos para que conozcas la próxima línea ALÉA Skin antes de su lanzamiento.
          </p>
        </div>

        <div className="rounded-2xl bg-background-100/80 p-4">
          <h2 className="font-heading text-sm font-bold text-foreground-950">Descripción</h2>
          <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">
            {product.description}
          </p>
        </div>

        <div className="grid grid-cols-3 gap-2">
          {[
            { icon: "ri-leaf-line", label: "Skincare" },
            { icon: "ri-time-line", label: "Pronto" },
            { icon: "ri-eye-line", label: "Conócelo" },
          ].map((item) => (
            <div
              key={item.label}
              className="flex flex-col items-center gap-1 rounded-2xl border border-background-200 bg-background-50 py-3"
            >
              <i className={`${item.icon} text-lg leading-none text-secondary-600`} />
              <span className="font-label text-[10px] font-semibold text-foreground-600">
                {item.label}
              </span>
            </div>
          ))}
        </div>

        <Link
          to="/productos"
          className="mt-1 inline-flex h-12 w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-full border border-background-300 bg-background-50 font-label text-sm font-semibold text-foreground-950 transition-colors hover:border-accent-400"
        >
          <i className="ri-arrow-left-line text-lg leading-none" />
          Volver a productos
        </Link>
      </div>
    </div>
  );
}



